import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import React from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, Field, NumericInput } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { MoistureContentMethodList } from '../../types';

let AsLinearShrinkageTestForMCSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const Method = useSelector(createWorksheetSelector!('Preparation.MoistureConditionTestMethod'));
  return (
    <>
      <ListFieldSection heading="Test For Moisture Condition">
        <Field
          input={<Dropdown />}
          name="Preparation.MoistureConditionTestMethod"
          simpleValue
          options={MoistureContentMethodList.map((e) => ({ label: e, value: e }))}
        />
        <Field
          input={<NumericInput />}
          name="Preparation.NumberOfBlows"
          visible={Method === MoistureContentMethodList[0] || Method === MoistureContentMethodList[1]}
        />

        <Field
          input={<NumericInput />}
          name="Preparation.ConePenetration"
          visible={Method === MoistureContentMethodList[2] || Method === MoistureContentMethodList[3]}
        />
      </ListFieldSection>
    </>
  );
};

AsLinearShrinkageTestForMCSection = withInjectedProps(AsLinearShrinkageTestForMCSection);

export { AsLinearShrinkageTestForMCSection };
export default AsLinearShrinkageTestForMCSection;
